import React, {lazy} from 'react';
import {Route, Routes} from 'react-router-dom';
import {ErrorBoundary} from '../AppInterface/elements/Errors/ErrorBoundary.js';
// import MailBlacklistView      from './views/blacklist/MailBlacklistView.js';
import {SurveyNotFoundView} from './views/SurveyNotFoundView/SurveyNotFoundView.js';

const MailBlacklistView = (
    lazy(() => (
        import(/* webpackChunkName: "MailBlacklistView" */'./views/blacklist/MailBlacklistView.js')
    ))
);

const SharedReportsView = (
    lazy(() => (
        import(/* webpackChunkName: "SharedReportsView" */'./views/reports/SharedReportView.js')
    ))
);

export const SurveyRoutes = () => {

    return (
        <ErrorBoundary>
            <Routes>
                <Route path={'/blacklist/:token'} element={
                    <MailBlacklistView/>}/>

                <Route path={'/reports/:reportId'} element={
                    <SharedReportsView/>}/>

                <Route exact path={'/'} element={
                    <SurveyNotFoundView/>}/>

                <Route element={
                    <SurveyNotFoundView/>}/>
            </Routes>
        </ErrorBoundary>
    );
};